import PageShell from "@/components/PageShell";
import { Nosotros } from "@/components/landing/Nosotros";
import { StatsTestimonials } from "@/components/landing/StatsTestimonials";

export default function NosotrosPage() {
  return (
    <PageShell crumbs={[{ label: "El Club" }]}>
      <Nosotros />
      <StatsTestimonials />
    </PageShell>
  );
}
